import { render } from "./MinimizeIcon.vue?vue&type=template&id=3d6f3bcc"
const script = {}

import exportComponent from "/app/tmp/origina/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__